import React, { useRef } from 'react';

import { Editor } from '@tinymce/tinymce-react';

import Loader from '../../../../../components/Loader';
import useDocument from './useAddDocument';

const AddDocument: React.FC = () => {
  const {
    loading,
    documentData,
    handleInputChange,
    handleFileChange,
    handleSave,
  } = useDocument();

  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6">
      {loading &&<Loader />}
      <div className="bg-white w-full shadow-md rounded-md p-4">
        <h1 className="text-2xl font-bold mb-4">Document Editor</h1>
        <form
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        >
          {/* Title Input */}
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Title</label>
            <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={documentData.title}
              onChange={(e) => handleInputChange("title", e.target.value)}
              placeholder="Enter document title"
            />
          </div>

          {/* Description Input (TinyMCE Editor) */}
          <label className="block text-gray-700 font-medium mb-2">Link</label>
          <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={documentData.link}
              onChange={(e) => handleInputChange("link", e.target.value)}
              placeholder="Enter document link"
            />
          <label className="block text-gray-700 font-medium mb-2">Tag</label>
          <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={documentData.tag}
              onChange={(e) => handleInputChange("tag", e.target.value)}
              placeholder="Enter document tag"
            />
          <label className="block text-gray-700 font-medium mb-2">Video Link</label>
          <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={documentData.video}
              onChange={(e) => handleInputChange("video", e.target.value)}
              placeholder="Enter Video Link"
            />

          {/* Save Button */}
          <button
            type="button"
            onClick={handleSave}
            className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
          >
            Save Document
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddDocument;
